<template>
  <div>
    <h2><span>{{ title }}</span> {{ name }}</h2>
    <p class="intro"><i>{{ intro }}</i></p>
    <p>{{ text_one }}</p>
    <p>{{ text_two }}</p>
    <p>{{ text_three }}</p>
    <p>{{ text_four }}</p>
  </div>
</template>

<script>

export default {
  // http://top-hun-pl.test/api/team/76
  name: 'HelloWorld',
  data() {
    return {
      title: 'Dr n. med.',
      name: 'Agnieszka Timorek-Lemieszczuk',
      intro: 'Od dziecka fascynowała się zdrowiem i pragnęła zostać lekarzem. Aby spełnić swoje marzenia, rozpoczęła studia na kierunku lekarskim Warszawskiego Uniwersytetu Medycznego, który ukończyła w 1992 r. Tym sposobem Mazowiecki Szpital Bródnowski zyskał ambitną stażystkę, dla której najważniejszym celem było zdrowie pacjenta. Kolejne lata doświadczenia w pracy w szpitalu pokazały, że zdrowie kobiety jest dla niej priorytetem. Chcąc pogłębiać swoją wiedzę i dzielić się nią z innymi w 1999r. uzyskała tytuł specjalisty drugiego stopnia w dziedzinie ginekologii i położnictwa, natomiast trzy lata później obroniła dysertację doktorską na Uniwersytecie Medycznym w Warszawie, otrzymując tytuł doktora nauk medycznych.',
      text_one: 'Od 2008 r. jest specjalistką w dziedzinie onkologii ginekologicznej. Podczas wielu lat pracy na szpitalnym oddziale, wykonała niezliczoną liczbę zabiegów chirurgicznych, zwłaszcza tych z użyciem technik histeroskopii i laparoskopii.',
      text_two: 'Dr Agnieszka Timorek-Lemieszczuk cieszy się nieposzlakowaną opinią zarówno wśród współpracowników, jak i pacjentek. W swoim gabinecie w Top Medical Clinic przyjmuje nie tylko pacjentki z Londynu Zachodniego, ale także z dalszych okolic. O jej zaangażowaniu i dokładności można usłyszeć od wszystkich pacjentek opuszczających gabinet polskiej pani ginekolog.',
      text_three: 'Dr Timorek-Lemieszczuk jest oddana swoim pacjentkom i nigdy nie zostawia nikogo w potrzebie. Spotykając się z dr Agnieszką w jej gabinecie na Isleworth ma się do czynienia z wysoce kompetentną osobą, która na pierwszym miejscu stawia pacjentkę i jej problemy.  Gabinet dr Timorek-Lemieszczuk w polskiej klinice w Londynie cieszy się dużą popularnością, co świadczy o wysokim zaufaniu pacjentek do polskiej ginekolog.',
      text_four: 'Poza codziennymi obowiązkami w gabinecie ginekologicznym dr Agnieszka Timorek-Lemieszczuk kontynuuje swoją pasję aktywnie uczestnicząc w konferencjach naukowych oraz badaniach klinicznych.  Jest autorką i współautorką dwudziestu artykułów oraz dwóch rozdziałów w publikacjach naukowych.',

      tasks: [],
      task: {
        firstname: '',
        surename: ''
      }
    }
  },
  methods: {
    fetchTasks: function () {
      const baseURI = 'http://top-hun-pl.test/api/team/76'
      this.$http.get(baseURI)
      .then((result) => {
        this.tasks = result.data
      })
    }
  },
  mounted() {
      this.fetchTasks();
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 { 
  margin-top: 20px;
  padding: 10px;
  font-weight: 400;
  text-align: left;
  & span {
    font-size: 80%;
    word-spacing: -3px;
    color: #00a3b6;
  }
}
p { 
  text-align: justify; 
  padding-left: 20px; 
  padding-right: 20px;
}
.intro {
  font-size: 100%;
}
</style>
